module.exports = __webpack_public_path__ + "static/media/to_the_moon_trans.6847e3b1.png";